<div [ngClass]="{ 'animate__animated animate__fadeIn animate__faster h-100': !clippedBody() }">
  <!-- Optional fixed filter bar -->
  <div [class]="clippedSearch() ? 'h-40px mt-3 me-3' : 'h-40px me-1 sticky-top bg-white pb-2'">
    @if (filterEntities(); as filterEntities) {
      <list-filter
        [clippedSearch]="clippedSearch()"
        [inputValue]="filterEntities()"
        (updateFilter)="filterEntities.set($event.target.value)" />
    } @else {
      <list-filter
        [clippedSearch]="clippedSearch()"
        [inputValue]="searchValue.coreSignal()"
        (updateFilter)="searchValue.coreSignal.set($event.target.value)" />
    }
  </div>

  <!-- Header Label -->
  @if(label(); as label) {
    <div class="position-relative mt-3">
      <div class="position-absolute legend-like-header">
        <div class="font-4 primary-text-200 px-1">
          {{ label }}
        </div>
      </div>
    </div>
  }
  <!-- Body Container -->
  <div
    [class]="
      clippedBody() ? 'clip4 padding-1 h-100  primary-gradient-bg-100 mt-3':
      'h-100'
    ">
    <div
      [class]="
        clippedBody() ? 'h-100 clip4 user-card overflow-wrap p-2 overflow-y-auto' : 'p-2 h-93 overflow-y-auto'
      ">
      <div class="d-flex flex-column h-100">
        <list-items
          (listItemClick)="selectEntity($event)"
          [entities]="displayEntities()"
          [template]="template()" />
      </div>
    </div>
  </div>
</div>
